export default class Route {
  constructor(module) {
    this.moduleRoot = module.ModuleRoot;
    this.sagas = module.sagas.default;
  }
}
